import script from "./ToolTip.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolTip.vue?vue&type=script&setup=true&lang=js"

import "./ToolTip.vue?vue&type=style&index=0&id=2482664f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2482664f"]])

export default __exports__